import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Posicionarte como la mejor opción', 'Crear demanda en lugar de perseguir alumnos', 'Tener ingresos más estables y predecibles'];
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <p className="text-xl md:text-2xl text-center mb-8" data-id="element-19">
          Esto no se trata de esforzarte más.
        </p>

        <h3 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-20">
          Se trata de:
        </h3>

        <div className="space-y-4 mb-8" data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-gradient-to-r from-primary/10 to-transparent p-5 rounded-lg" data-id="element-22">
              <div className="bg-primary rounded-full p-1" data-id="element-23">
                <CheckIcon className="w-5 h-5 text-white" data-id="element-24" />
              </div>
              <p className="text-lg font-semibold" data-id="element-25">{benefit}</p>
            </motion.div>)}
        </div>

        <p className="text-xl text-center text-gray-300" data-id="element-26">
          Para que finalmente tengas control sobre tu tiempo y tu dinero.
        </p>
      </div>
    </motion.section>;
}